export default __webpack_public_path__ + "static/image-Hero-b4e8d85bd8f710f3f3dada351f73be59.png";